import React, { useEffect, useState } from 'react';
import { Box, Card, Typography, Breadcrumbs, Divider, Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { useDispatch } from 'react-redux';
import { useResponseHandler } from 'hooks/useResponseHandler';
import formInitialValues from './formik/formInitialValues';
import validationSchema from './formik/validationSchema';
import suscripcionesFormModel from './formik/suscripcionesFormModel';
import { SuscripcionesForm } from './components/forms/SuscripcionesForm';
import {
  getFormsSuscriptionsStore,
  saveServicesIaCustomerSuscriptionStore,
} from 'store/services-ia-customer-suscriptions/thunks';
import { MessagesDrawerRight } from 'components/MessagesDrawerRight';
import { servicesIaCustomerSuscriptionsMapper } from './mappers/suscripciones.mapper';

export const CreateSuscripciones = () => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const { handleResponse, ResponseComponents } = useResponseHandler();
  const { formId, formField } = suscripcionesFormModel;
  const [dataErrors, setMsgErrors] = useState([]);

  useEffect(() => {
    getFormData();
  }, []);

  const getFormData = async () => {
    const response = await dispatch(getFormsSuscriptionsStore());
    await handleResponse(response, 'obtener datos del formulario', false);
  };

  const onSubmit = async (values: any, actions: any) => {
    const payload = servicesIaCustomerSuscriptionsMapper.toDto(values);
    const response = await dispatch(saveServicesIaCustomerSuscriptionStore(payload));

    await handleResponse(response, 'Suscripción Creada', true);
    actions.setSubmitting(false);

    if (!response.error && response.code !== 400) {
      actions.resetForm();
    }
  };

  return (
    <Box sx={{ width: '100%', mb: 5 }}>
      {ResponseComponents}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 1, color: 'text.primary' }}>
            Crear Suscripción
          </Typography>
          <Breadcrumbs aria-label="breadcrumb">
            <Link color="inherit" to="/manager/plataforma-ia/comercial/suscripciones">
              Suscripciones
            </Link>
            <Typography color="text.primary">Crear Suscripción</Typography>
          </Breadcrumbs>
        </Box>
      </Box>

      <Card sx={{ p: 4, borderRadius: 3, boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)' }}>
        <Formik
          initialValues={formInitialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {(props) => (
            <Form id={formId}>
              <SuscripcionesForm formField={formField} isEditing={false} />

              <Divider sx={{ my: 4 }} />

              <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                <Button
                  component={Link}
                  to="/manager/plataforma-ia/comercial/suscripciones"
                  variant="outlined"
                  color="inherit"
                  sx={{ borderRadius: 2, px: 3 }}
                >
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={props.isSubmitting}
                  sx={{
                    borderRadius: 2,
                    px: 4,
                    boxShadow: '0px 4px 10px rgba(105, 108, 255, 0.3)',
                  }}
                >
                  {props.isSubmitting ? 'Guardando...' : 'Guardar Suscripción'}
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
      </Card>

      <MessagesDrawerRight data={dataErrors} open={dataErrors.length > 0} setMsg={setMsgErrors} />
    </Box>
  );
};
